<app-logiciel-caisse-list-toolbar
  [(searchTerm)]="searchTerm"
  (searchTermChange)="applySearch()"
  primaryLabel="+ Nouveau mode"
  (primaryClick)="openCreate(typeModeModal)"
></app-logiciel-caisse-list-toolbar>

<div class="table-full-width">
  <div class="table-responsive lc-table-scroll">
    <table class="table table-hover pos-ticket-table">
      <thead class="custom-header">
        <tr>
          <th style="width: 56px">Logo</th>
          <th>Libellé</th>
          <th>Mode</th>
          <th>Affectation</th>
          <th>Type</th>
          <th>Manuel</th>
          <th>Actif</th>
          <th style="width: 140px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="loading" class="lc-loading-row">
          <td colspan="8">
            <span class="spinner-border spinner-border-sm mr-1"></span>
            Chargement des modes de paiement…
          </td>
        </tr>
        <tr *ngFor="let row of filteredRows" [hidden]="loading">
          <td>
            <span class="tmp-logo-cell">
              <img *ngIf="logoSrc(row) as src" [src]="src" [alt]="row.libelle" class="tmp-logo-img" />
              <span *ngIf="!logoSrc(row)" class="tmp-logo-letter" aria-hidden="true">{{ initialOf(row.libelle) }}</span>
            </span>
          </td>
          <td>{{ row.libelle }}</td>
          <td><code>{{ row.mode || '—' }}</code></td>
          <td>{{ row.affectation || '—' }}</td>
          <td>{{ row.type || '—' }}</td>
          <td>{{ boolLabel(row.is_manuelle) }}</td>
          <td>
            <span
              class="badge"
              [class.badge-light-success]="isActive(row)"
              [class.badge-light-secondary]="!isActive(row)"
            >
              {{ isActive(row) ? 'Actif' : 'Inactif' }}
            </span>
          </td>
          <td class="d-flex align-items-center flex-nowrap">
            <button
              type="button"
              class="btn btn-sm btn-icon btn-outline-primary mr-50"
              title="Modifier"
              (click)="openEdit(row, typeModeModal)"
            >
              <i data-feather="edit" [size]="16"></i>
            </button>
            <button
              type="button"
              class="btn btn-sm btn-icon btn-outline-danger"
              title="Désactiver"
              [disabled]="!isActive(row)"
              (click)="deactivate(row)"
            >
              <i data-feather="slash" [size]="16"></i>
            </button>
          </td>
        </tr>
        <tr *ngIf="!loading && filteredRows.length === 0" class="lc-empty-row">
          <td colspan="8">Pas de données à afficher</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<ng-template #typeModeModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ editId ? 'Modifier' : 'Créer' }} mode de paiement</h4>
    <button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label>Logo <span class="text-muted">(optionnel)</span></label>
      <div class="tmp-logo-upload">
        <div class="tmp-logo-preview" aria-hidden="true">
          <img *ngIf="logoPreview" [src]="logoPreview" alt="" class="tmp-logo-img tmp-logo-img--lg" />
          <span *ngIf="!logoPreview" class="tmp-logo-letter tmp-logo-letter--lg">{{ formInitial() }}</span>
        </div>
        <div class="tmp-logo-upload-actions">
          <input
            #logoInput
            type="file"
            class="d-none"
            [accept]="logoConstraints.accept"
            (change)="onLogoSelected($event)"
          />
          <button type="button" class="btn btn-sm btn-outline-primary" (click)="logoInput.click()">
            Choisir une image
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            *ngIf="logoPreview || existingLogo"
            (click)="clearLogo(); logoInput.value = ''"
          >
            Retirer
          </button>
          <small class="text-muted d-block mt-50">{{ logoConstraints.hint }}</small>
          <div class="invalid-feedback d-block" *ngIf="logoError">{{ logoError }}</div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label>Libellé <span class="text-danger">*</span></label>
      <input type="text" class="form-control" [(ngModel)]="form.libelle" name="tmp_libelle" />
    </div>
    <div class="form-group">
      <label>Mode (codification)</label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="form.mode"
        name="tmp_mode"
        placeholder="Ex. ESPECES (auto si vide)"
      />
    </div>
    <div class="form-group">
      <label>Affectation</label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="form.affectation"
        name="tmp_affectation"
        placeholder="Ex. caisse"
      />
    </div>
    <div class="form-group">
      <label>Type <span class="text-muted">(optionnel)</span></label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="form.type"
        name="tmp_type"
        placeholder="Non obligatoire"
      />
    </div>
    <div class="custom-control custom-checkbox mb-1">
      <input
        type="checkbox"
        class="custom-control-input"
        id="tmp_manuelle"
        [(ngModel)]="form.is_manuelle"
        name="tmp_manuelle"
      />
      <label class="custom-control-label" for="tmp_manuelle">Saisie manuelle</label>
    </div>
    <div class="custom-control custom-checkbox mb-1">
      <input
        type="checkbox"
        class="custom-control-input"
        id="tmp_active"
        [(ngModel)]="form.active"
        name="tmp_active"
      />
      <label class="custom-control-label" for="tmp_active">Actif</label>
    </div>
    <div class="custom-control custom-checkbox">
      <input
        type="checkbox"
        class="custom-control-input"
        id="tmp_sodexo"
        [(ngModel)]="form.is_sodexo"
        name="tmp_sodexo"
      />
      <label class="custom-control-label" for="tmp_sodexo">Sodexo</label>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()" [disabled]="saving">
      Annuler
    </button>
    <button type="button" class="btn btn-primary" (click)="save(modal)" [disabled]="saving">
      {{ saving ? 'Enregistrement…' : 'Enregistrer' }}
    </button>
  </div>
</ng-template>
